import { Button, Form, Input } from 'antd';

import { InfoTooltip } from './InfoTooltip';
import {
  FormBody,
  StepTitle,
  StepSubtitle,
  SubmitButton,
} from './styles';
import type { SubmitterData } from './types';

interface StepUserDataProps {
  initialValues: SubmitterData | null;
  onContinue: (data: SubmitterData) => void;
}

export const StepUserData = ({ initialValues, onContinue }: StepUserDataProps) => {
  const [form] = Form.useForm();

  const handleFinish = (values: SubmitterData) => {
    onContinue(values);
  };

  return (
    <FormBody>
      <StepTitle>Seus Dados</StepTitle>
      <StepSubtitle>
        Preencha seu nome para que possamos identificar quem está fazendo a solicitação.
      </StepSubtitle>

      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        requiredMark={false}
        initialValues={initialValues || undefined}
      >
        <Form.Item
          name="submitter_name"
          label={
            <span>
              Seu nome completo
              <InfoTooltip text="Nome da pessoa que está solicitando a nota fiscal. Não precisa ser o mesmo nome do tomador." />
            </span>
          }
          rules={[{ required: true, message: 'Por favor, informe seu nome completo' }]}
          style={{ marginBottom: 24 }}
        >
          <Input placeholder="Ex: Maria da Silva Souza" autoComplete="name" />
        </Form.Item>
        <SubmitButton>
          <Button type="primary" htmlType="submit" block size="large">
            Continuar
          </Button>
        </SubmitButton>
      </Form>
    </FormBody>
  );
};
